export default __webpack_public_path__ + "static/media/f-second1.17ee45c7.png";